import Input from "./Input";
import Tags from "./Tags";
import DateTime from "./DateTime"
import Radio from "./Radio"
import CheckBox from "./CheckBox"
import TextArea from "./TextArea"
import HTML from "./HTML"
import Select from "./Select"
import Image from "./Image"
import File from "./File"
import Color from "./Color"
import Relation from "./Relation"
import Icons from "./Icons"

export {HTML,Input,Tags,DateTime,Radio,CheckBox,TextArea,Select,Image,File,Color,Relation,Icons};



// WEBPACK FOOTER //
// ./src/components/fields/index.js